import React, { MouseEvent, memo, useMemo } from 'react';
import { HeaderType } from '../../libraries/HeaderThemes';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Header.scss';
const rootClassName = 'component-header';

interface HeaderProps {
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
  theme?: HeaderType;
  leftContent?: React.ReactNode;
  centerContent?: React.ReactNode;
  rightContent?: React.ReactNode;
  clearfix?: boolean;
  onClick?: (event?: MouseEvent) => void;
  disabled?: boolean;
  className?: string;
  position?: 'fixed' | 'static' | 'absolute' | 'relative' | 'sticky';
  blackBar?: {
    show: boolean;
    label: string;
    link: string;
    icon: React.ReactNode;
    target?: '_blank';
  };
  separator?: {
    show?: boolean;
    label?: string;
  };
}

function Header(props: HeaderProps) {
  const p = useMemo(
    () => ({
      onClick: (evt: MouseEvent) => {
        if (!props.disabled) {
          props.onClick?.(evt);
        }
      },
      className: getMergedClassNames([
        rootClassName,
        props.className,
        `${rootClassName}-${props.theme}`,
        props.blackBar && props.blackBar.show ? 'has-black-bar' : '',
      ]),
    }),
    [props]
  );

  const clearfixClassNames = getMergedClassNames([
    `${rootClassName}-clearfix`,
    `${rootClassName}-${props.theme}`,
  ]);

  return (
    <React.Fragment>
      <header {...p} style={{ position: props.position }}>
        {props.blackBar && props.blackBar.show ? (
          <div className={`${rootClassName}-black-bar`}>
            <a href={props.blackBar.link} target={props.blackBar?.target}>
              {props.blackBar.icon}
              <span className='nunito'>{props.blackBar.label}</span>
            </a>
          </div>
        ) : undefined}
        <div className={`${rootClassName}-header-item`}>
          {props.leftContent}
          {props.separator && props.separator.show ? (
            <div className={`${rootClassName}-separator-logo`}>
              {props.separator.label}
            </div>
          ) : undefined}
        </div>
        <div className={`${rootClassName}-header-item`}>
          {props.centerContent}
        </div>
        <div className={`${rootClassName}-header-item`}>
          {props.rightContent}
        </div>
      </header>
      {props.theme === HeaderType.Semi && (
        <div className={`${rootClassName}-semi-clear`} />
      )}
      {props.clearfix && <div className={clearfixClassNames} />}
    </React.Fragment>
  );
}

Header.defaultProps = {
  position: 'fixed',
  theme: HeaderType.Verde,
};

export default memo(Header);
